import React, { useContext, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import './styles/typography.css';
import './styles/design-system.css';
import TarifaEnergetica from './pages/TarifaEnergetica/TarifaEnergetica';
import Login from './pages/Login';
import Navbar from './components/Navbar';
import VerticalMenu from './components/VerticalMenu';
import Footer from './components/Footer';
import Reservas from './pages/MovilidadElectrica/Reservas';
import VehiculosRegistrados from './pages/MovilidadElectrica/VehiculosRegistrados';
import UsuariosRegistrados from './pages/MovilidadElectrica/UsuariosRegistrados';
import ReservasParqueaderos from './pages/MovilidadElectrica/ReservasParqueaderos';
import MatrizConsumos from './pages/MovilidadElectrica/MatrizConsumos';
import ControlCargadoresPage from './pages/MovilidadElectrica/ControlCargadoresPage';
import CeldasPage from './pages/MovilidadElectrica/CeldasPage';
import MisReservas from './pages/MovilidadElectrica/MisReservas';
import VehiculosPage from './pages/MovilidadElectrica/VehiculosPage';
import MiBilleteraPage from './pages/Billetera/MiBilleteraPage';
import PaymentStatusPage from './pages/Billetera/PaymentStatusPage';
import GestionFinancieraPage from './pages/Admin/GestionFinancieraPage';
import AllWalletsPage from './pages/Admin/AllWalletsPage';
import DashboardPage from './pages/Admin/DashboardPage';
import ComunicadoPage from './pages/Admin/ComunicadoPage';
import DetalleReservaPage from './pages/MovilidadElectrica/DetalleReservaPage';
import SettingsPage from './pages/SettingsPage';
import FacturacionPage from './pages/Facturacion/FacturacionPage';
import AuthProvider from './context/AuthContext';
import { ModalProvider } from './context/ModalContext';
import { PlaceProvider } from './context/PlaceContext';
import { MovilidadElectricaProvider } from './context/MovilidadElectricaContext';
import { AnnouncementProvider } from './context/AnnouncementContext';
import { AuthContext } from './context/AuthContext';
import AnnouncementBanner from './components/Announcement/AnnouncementBanner';
import AnnouncementModal from './components/Announcement/AnnouncementModal';
import { MigrationProvider } from './context/MigrationContext';
import MigrationCodeModal from './components/Migration/MigrationCodeModal';
import MigracionPage from './pages/Admin/MigracionPage';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!sessionStorage.getItem('token');
  return isAuthenticated ? children : <Navigate to="/login" />;
};

const AdminRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const isAuthenticated = !!sessionStorage.getItem('token');

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return user && user.is_admin ? children : <Navigate to="/" />;
};

const Layout = ({ children }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Navbar toggleMenu={toggleMenu} />
      <VerticalMenu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
      <Box
        className="main-content"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          width: '100%',
          backgroundColor: '#F5F5F5'
        }}
      >
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            mt: { xs: '56px', sm: '64px' },
            pb: { xs: '16px', sm: '24px' }
          }}
        >
          <AnnouncementBanner />
          <AnnouncementModal />
          {children}
        </Box>
        <Footer />
        {/* Migración a ActionEV: el código sale nada más entrar, en cualquier ruta privada */}
        <MigrationCodeModal />
      </Box>
    </Box>
  );
};

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <PlaceProvider>
          <AnnouncementProvider>
          <MigrationProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/login" />} />
      <Route
        path="/tarifa-energetica"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <TarifaEnergetica />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/reservas"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <Reservas />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/vehiculosRegistrados"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <VehiculosRegistrados />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/usuariosRegistrados"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <UsuariosRegistrados />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/reservasParqueaderos"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <ReservasParqueaderos />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/matrizConsumos"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <MatrizConsumos />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/controlCargadores"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <ControlCargadoresPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/celdas"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <CeldasPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/mis-reservas"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <MisReservas />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/mis-vehiculos"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <VehiculosPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/mi-billetera"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <MiBilleteraPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-status"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <PaymentStatusPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-status/wompi"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <PaymentStatusPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/payment-status/mercadopago"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <PaymentStatusPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/movilidadElectrica/reserva/:bookingId"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <DetalleReservaPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/finanzas"
        element={
          <AdminRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <GestionFinancieraPage />
              </Layout>
            </MovilidadElectricaProvider>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/billeteras"
        element={
          <AdminRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <AllWalletsPage />
              </Layout>
            </MovilidadElectricaProvider>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <AdminRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <DashboardPage />
              </Layout>
            </MovilidadElectricaProvider>
          </AdminRoute>
        }
      />
      <Route
        path="/admin/migracion"
        element={
          <AdminRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <MigracionPage />
              </Layout>
            </MovilidadElectricaProvider>
          </AdminRoute>
        }
      />
      <Route
        path="/ajustes"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <SettingsPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/facturacion"
        element={
          <PrivateRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <FacturacionPage />
              </Layout>
            </MovilidadElectricaProvider>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/comunicado"
        element={
          <AdminRoute>
            <MovilidadElectricaProvider>
              <Layout>
                <ComunicadoPage />
              </Layout>
            </MovilidadElectricaProvider>
          </AdminRoute>
        }
      />
      <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
          </MigrationProvider>
          </AnnouncementProvider>
        </PlaceProvider>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;
